export enum Action {
  RESUBMIT = "RESUBMIT",
  APPEAL = "APPEAL",
  WRITE_OFF = "WRITE_OFF",
  PATIENT_RESPONSIBILITY = "PATIENT_RESPONSIBILITY",
  DUPLICATE = "DUPLICATE",
  SECONDARY_INSURANCE = "SECONDARY_INSURANCE",
  COMPLETED = "COMPLETED",
  SUBMIT_QUESTIONNAIRE = "SUBMIT_QUESTIONNAIRE",
  NEEDS_REVIEW = "NEEDS_REVIEW",
  CALL_PAYER = "CALL_PAYER",
}

const actionLabels = new Map<Action, { label: string }>([
  [Action.RESUBMIT, { label: "✈️ Resubmit" }],
  [Action.APPEAL, { label: "🏛 Appeal" }],
  [Action.WRITE_OFF, { label: "💸 Write Off" }],
  [Action.PATIENT_RESPONSIBILITY, { label: "🤒 Patient Responsibility" }],
  [Action.SECONDARY_INSURANCE, { label: "📨 Secondary Insurance" }],
  [Action.COMPLETED, { label: "🏁 Completed" }],
  [Action.DUPLICATE, { label: "📋 Duplicate" }],
  [Action.SUBMIT_QUESTIONNAIRE, { label: "❓ Submit Questionnaire" }],
  [Action.NEEDS_REVIEW, { label: "🔍 Needs Review" }],
]);

export const needsWorkActionLabels = new Map<Action, { label: string }>([
  ...Array.from(actionLabels.entries()),
  [Action.CALL_PAYER, { label: "📞 Call Payer" }],
]);

export default actionLabels;
